/**
 * Mã gói cho người đọc: `G-` + 8 ký tự đầu của id (uuid), viết HOA — `G-7K2QXM4P`.
 *
 * Vì sao có: mẫu ZBS "gói sắp hết hạn" gửi lại sau khi bị từ chối CT_13 bắt buộc cặp "Khách hàng + Mã gói"
 * (docs/zalo/xin-duyet.md, Mẫu 5). Khách phải đối chiếu được mã trong tin với mã ở "Của tôi" → một hàm dùng chung
 * cho Mini App, web quầy và worker, không ba cách viết.
 */
export function maGoi(packageId: string): string {
  return `G-${packageId.replace(/-/g, '').slice(0, 8).toUpperCase()}`
}
